module.exports = __webpack_public_path__ + "f53c1e6b385d9740cd059aed473180ca.svg";